import { FlexRow } from '@/components/common/Flex';
import { FlexProps, forwardRef } from '@chakra-ui/react';
import { FC } from 'react';
import { Button, ButtonProps } from './Button';

export interface ButtonWithIconProps extends ButtonProps {
    iconLeft?: JSX.Element;
    iconRight?: JSX.Element;
    gap?: FlexProps['gap'];
}

const gapForSize = (size: ButtonProps['size']): FlexProps['gap'] => {
    switch (size) {
        case 'xs':
            return 1;
        case 'sm':
        case 'md':
            return 2;
        case 'lg':
            return 3;
        default:
            return 2;
    }
};

const ButtonWithIcon: FC<ButtonWithIconProps> = forwardRef(
    ({ children, iconLeft, iconRight, size, gap, ...props }, ref) => {
        if (!gap) {
            gap = gapForSize(size);
        }

        return (
            <Button size={size} {...props} ref={ref}>
                <FlexRow
                    w="full"
                    align="center"
                    justify="space-between"
                    gap={gap}
                >
                    {iconLeft}
                    {children}
                    {iconRight}
                </FlexRow>
            </Button>
        );
    }
);

export default ButtonWithIcon;
